import { ReactElement, useState } from 'react';
import { space } from '@op/opds.tokens';
import { Message, useMessage } from '@messageformat/react';
import { Alert, Col, Row } from '@op/opds.opux';
import CourseTaskHeader from '../CourseTaskHeader';
import DropdownQuestionTile from './DropdownQuestionTile';
import { getMsgValues } from '../../utils';

const TaskTwo = (): ReactElement => {
  const options = getMsgValues(useMessage('course3.task2.options'));
  const defaultAnswers = new Array(options.length).fill(null);

  const [selectedOptions, setSelectedOptions] = useState(defaultAnswers);
  const [correctAnswers, setCorrectAnswers] = useState(0);

  const updateAnswers = (value: number): void => {
    if (correctAnswers + value >= 0) {
      setCorrectAnswers(correctAnswers + value);
    }
  };

  return (
    <div style={{ marginTop: space.xxl }}>
      <CourseTaskHeader questionNumber={2} totalQuestions={2} />
      <h3
        className="opds-styles-v1-text-hero-small"
        style={{ textAlign: 'center', marginTop: space.xxl }}
      >
        <Message id="course3.task2.title" />
      </h3>
      <div
        className="opds-styles-v1-text-body-medium"
        style={{
          textAlign: 'center',
          paddingBottom: space.default,
          paddingTop: space.default,
        }}
      >
        <Message id="course3.task2.body" />
      </div>
      <Row style={{ marginTop: space.default, marginLeft: 0, marginRight: 0 }}>
        <Col
          style={{ display: 'flex', flexDirection: 'column' }}
          xs={12}
          md={6}
          className="investoracademy-multi-column-left-small-padding"
        >
          <DropdownQuestionTile
            number="1"
            correctAnswer={options[0]}
            options={options}
            selectedOptions={selectedOptions}
            setSelectedOptions={setSelectedOptions}
            updateAnswers={updateAnswers}
          />
          <DropdownQuestionTile
            number="2"
            correctAnswer={options[1]}
            options={options}
            selectedOptions={selectedOptions}
            setSelectedOptions={setSelectedOptions}
            updateAnswers={updateAnswers}
          />
        </Col>
        <Col
          style={{ display: 'flex', flexDirection: 'column' }}
          xs={12}
          md={6}
          className="investoracademy-multi-column-right-small-padding"
        >
          <DropdownQuestionTile
            number="3"
            correctAnswer={options[2]}
            options={options}
            selectedOptions={selectedOptions}
            setSelectedOptions={setSelectedOptions}
            updateAnswers={updateAnswers}
          />
          <DropdownQuestionTile
            number="4"
            correctAnswer={options[3]}
            options={options}
            selectedOptions={selectedOptions}
            setSelectedOptions={setSelectedOptions}
            updateAnswers={updateAnswers}
          />
        </Col>
      </Row>
      {correctAnswers === 4 && (
        <Alert type="positive">
          <Message id="answers_correct" />
        </Alert>
      )}
    </div>
  );
};

export default TaskTwo;
